import { SemanticICONS } from 'semantic-ui-react'
import { IndexSearchOption } from '../IndexSearch/types'

export type FineManagerDashboardFetch = {
	cards: {
		cardTitle: string
		cardBodyIcon?: SemanticICONS
		cardBodyText?: number
		cardLink: string
		notReact?: boolean
	}[]
}

export type FineManagerIndexFetch = {
	headings?: {
		customer: string
		supplier: string
		reference: string
		fineReferenceNumber: string
		type: string
		registration: string
		createdDate: string
		firstNotification: string
		salesDate: string
		purchaseDate: string
	}
	data: {
		id: string
		customer?: string
		supplier: string
		reference: string
		fineReferenceNumber: string
		type: string
		registration: string
		createdDate: string
		firstNotification: string
		salesDate: string
		purchaseDate: string
	}[]
	options: {
		[key: string]: { label: string; values: { [key: string]: string }[] }
	}
}

export type FineManagerSearchOptionsFetch = {
	customer?: IndexSearchOption
	supplier?: IndexSearchOption
	status: IndexSearchOption
	reference: IndexSearchOption
	type: IndexSearchOption
}
